/**
 * The primary action leads (Chris, 2026-10-29). After "draw the cards yourself
 * for Chi" the row read [Change the Subject] [◈ Draw the cards]: whenever a set
 * of tool chips has a primary, it comes first, and the rest keep their order.
 */

const PRIMARY_TYPES = new Set(['select_cards', 'rate_reading', 'share_reading', 'lesson_full_reading'])

/** The action the moment is for: Draw the cards, Rate / Share, Go deeper. */
export function isPrimaryChip(action) {
  return !!action && (!!action._draw || PRIMARY_TYPES.has(action.action_type))
}

/** Primaries first, the rest after; order within each is kept. */
export function primaryFirst(actions) {
  const list = Array.isArray(actions) ? actions.filter(Boolean) : []
  return [...list.filter(isPrimaryChip), ...list.filter((a) => !isPrimaryChip(a))]
}

/**
 * Tool chips speak in sentence case. The server still says "Change the
 * Subject"; only known labels are mended, so names ("Gift to Chi") keep their
 * capitals.
 */
export function toolChipLabel(label, action) {
  const text = String(label || '')
  if (action && action.action_type === 'reset_conversation' && /^change the subject$/i.test(text.trim())) {
    return 'Change the subject'
  }
  return text
}
